
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconDragHorizontial = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M5 16.5a.5.5 0 01-.35-.15l-4-4a.5.5 0 010-.71l4-4a.5.5 0 01.71.71L1.71 12l3.65 3.65a.5.5 0 01-.36.85zM19 16.5a.5.5 0 01-.35-.85L22.29 12l-3.64-3.65a.5.5 0 01.71-.71l4 4a.5.5 0 010 .71l-4 4a.5.5 0 01-.36.15z' }),
    React.createElement('circle', { cx: '9.22', cy: '14.78', r: '1.22' }),
    React.createElement('circle', { cx: '9.22', cy: '9.22', r: '1.22' }),
    React.createElement('circle', { cx: '14.78', cy: '14.78', r: '1.22' }),
    React.createElement('circle', { cx: '14.78', cy: '9.22', r: '1.22' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M5 16.5a.5.5 0 01-.35-.15l-4-4a.5.5 0 010-.71l4-4a.5.5 0 01.71.71L1.71 12l3.65 3.65a.5.5 0 01-.36.85zM19 16.5a.5.5 0 01-.35-.85L22.29 12l-3.64-3.65a.5.5 0 01.71-.71l4 4a.5.5 0 010 .71l-4 4a.5.5 0 01-.36.15z' }),
    React.createElement('circle', { cx: '9.22', cy: '14.78', r: '1.22' }),
    React.createElement('circle', { cx: '9.22', cy: '9.22', r: '1.22' }),
    React.createElement('circle', { cx: '14.78', cy: '14.78', r: '1.22' }),
    React.createElement('circle', { cx: '14.78', cy: '9.22', r: '1.22' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M5 16.5a.5.5 0 01-.35-.15l-4-4a.5.5 0 010-.71l4-4a.5.5 0 01.71.71L1.71 12l3.65 3.65a.5.5 0 01-.36.85zM19 16.5a.5.5 0 01-.35-.85L22.29 12l-3.64-3.65a.5.5 0 01.71-.71l4 4a.5.5 0 010 .71l-4 4a.5.5 0 01-.36.15z' }),
    React.createElement('circle', { cx: '9.22', cy: '14.78', r: '1.22' }),
    React.createElement('circle', { cx: '9.22', cy: '9.22', r: '1.22' }),
    React.createElement('circle', { cx: '14.78', cy: '14.78', r: '1.22' }),
    React.createElement('circle', { cx: '14.78', cy: '9.22', r: '1.22' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconDragHorizontial.displayName = 'IconDragHorizontial';
export default IconDragHorizontial;